import { OPEN_CONTACT_MODAL, TOGGLE_CONTACT_MODAL } from '../actions/contactModal';

const initialState = {
  isOpen: false,
};

export default (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type) {
    case TOGGLE_CONTACT_MODAL:
      return {
        ...state,
        isOpen: !state.isOpen,
      };
    case OPEN_CONTACT_MODAL:
      return {
        ...state,
        isOpen: true,
      };
    /* istanbul ignore next -- @preserve */
    default:
      return state;
  }
};
